module.exports = __webpack_public_path__ + "img/time-13.4e33e553.png";